import { useLocalization } from "@fluent/react";
import { Checkbox } from "@narmi/design_system";

import { useInstitutionSettings } from "../../../components/contexts/InstitutionSettingsContext";

import styles from "./SmsOptInDisclosure.module.scss";

type SmsOptInDisclosureProps = {
  consented: boolean;
  onConsentChange: (consented: boolean) => void;
};

const SmsOptInDisclosure = ({
  consented,
  onConsentChange,
}: SmsOptInDisclosureProps) => {
  const { l10n } = useLocalization();
  const institution = useInstitutionSettings();

  const label = l10n.getElement(<p />, "sms-disclosure-2fa-opt-in", {
    vars: { institutionName: institution.long_name || "" },
    elems: {
      privacyUrl: (
        <a
          href={institution.privacy_url || "#"}
          target="_blank"
          rel="noopener noreferrer"
        />
      ),
      termsUrl: (
        <a
          href={institution.terms_url || "#"}
          target="_blank"
          rel="noopener noreferrer"
        />
      ),
    },
  });

  return (
    <div className={styles.disclosure}>
      <Checkbox
        checked={consented}
        onChange={(event) => onConsentChange(event.target.checked)}
        label={label as unknown as string}
      />
    </div>
  );
};

export default SmsOptInDisclosure;
